module.exports = __webpack_public_path__ + "static/img/1936.d52e517.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1936.jpg
// module id = qdzX
// module chunks = 0